<template>
	<div class="top-section dispalynone">
		<div class="top-banner">
			<div class="text-wrap fade-in-top">
				<div class="left">
					<span class="white-color-text">{{$t('人工智能累积收益')}}</span>
					<div class="svg-container svg-img white">
						<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"
							class="svg-class">
							<path id="Vector"
								d="M11.0033 0.224642C12.5947 0.155553 14.2086 0.696206 15.4091 1.73439C15.605 1.89621 15.7784 2.08122 15.9583 2.25928C16.0175 2.32744 16.1148 2.28014 16.1904 2.27597C17.8476 1.96901 19.6227 2.34784 20.9974 3.31323C22.5535 4.38433 23.5788 6.17368 23.7009 8.04278C23.7502 8.81898 23.6553 9.60307 23.4171 10.3445C23.3875 10.3974 23.4115 10.4498 23.4524 10.4887C24.1266 11.2464 24.6134 12.1658 24.8549 13.1456C24.9742 13.6162 25.0212 14.1003 25.0489 14.5835C25.0287 15.3699 24.9018 16.1605 24.6072 16.8945C24.1078 18.1779 23.1761 19.2963 21.985 20.0118C21.385 20.373 20.7216 20.6271 20.0371 20.7797C19.9511 20.7885 19.9464 20.8858 19.9172 20.9466C19.4277 22.3446 18.4133 23.5553 17.1151 24.2944C15.6412 25.1457 13.8168 25.372 12.1742 24.912C11.0503 24.6074 10.0251 23.9754 9.23718 23.1301C9.16765 23.029 9.03985 23.0851 8.94212 23.0962C7.39586 23.3726 5.75046 23.0559 4.42644 22.2199C2.88534 21.2651 1.80846 19.6283 1.52843 17.8566C1.38231 16.9107 1.4603 15.9323 1.75395 15.0203C1.7906 14.9544 1.73939 14.8974 1.6971 14.8515C0.770097 13.8063 0.213799 12.4487 0.143323 11.0614C0.110433 10.829 0.11889 10.594 0.147081 10.3617C0.220846 9.05546 0.729219 7.78173 1.56085 6.76441C2.42771 5.6947 3.66294 4.9222 5.01703 4.61617C5.09785 4.59392 5.21296 4.59021 5.22799 4.48681C5.46996 3.78526 5.83456 3.12404 6.30911 2.54862C7.43768 1.15293 9.19725 0.290021 11.0033 0.224642ZM9.70233 2.0956C8.81104 2.40163 8.01934 2.97984 7.45741 3.72729C6.93588 4.41354 6.61263 5.24493 6.54121 6.10042C6.49657 6.67028 6.52524 7.24293 6.51725 7.81419C6.52477 9.32625 6.50268 10.8388 6.52852 12.3504C7.2488 12.7654 7.96625 13.1883 8.69968 13.5805C8.7119 11.2408 8.70062 8.90106 8.70532 6.56132C8.7025 6.26827 8.88715 5.99516 9.14697 5.86116C10.8614 4.88789 12.5707 3.90674 14.2861 2.93579C14.156 2.78185 13.976 2.68169 13.8107 2.56948C12.6093 1.80441 11.0503 1.62774 9.70233 2.0956ZM14.9655 4.41354C13.2981 5.36363 11.6315 6.3151 9.9631 7.26426C9.91705 7.29765 9.83342 7.32361 9.84798 7.39548C9.84892 8.20043 9.84329 9.00585 9.85127 9.8108C11.9021 8.64974 13.9469 7.47709 15.9959 6.31232C16.2473 6.16209 16.5771 6.16812 16.8271 6.31974C18.0665 7.02732 19.3069 7.73397 20.5473 8.44062C21.0355 8.70956 21.5086 9.00817 22.0071 9.25763C22.1518 8.38637 22.055 7.47292 21.7045 6.65869C21.3554 5.83519 20.763 5.11324 20.015 4.61107C19.2566 4.09824 18.3447 3.80612 17.4252 3.7936C16.5677 3.7681 15.7079 3.99067 14.9655 4.41354ZM2.46248 8.30383C1.98559 9.0703 1.74784 9.97633 1.77698 10.874C1.80799 11.8236 2.13594 12.7626 2.71197 13.5244C3.1151 14.0679 3.64602 14.5144 4.24226 14.8404C5.89141 15.7788 7.53916 16.7201 9.18832 17.6586C9.26209 17.7184 9.34337 17.654 9.41056 17.6192C9.95558 17.3048 10.5034 16.9956 11.0494 16.683C11.1762 16.6079 11.3148 16.5486 11.4253 16.4489C9.38519 15.2855 7.34465 14.123 5.30458 12.9597C5.01468 12.8122 4.86762 12.4876 4.87561 12.1756C4.87467 10.23 4.87373 8.28482 4.87608 6.33921C3.87578 6.69718 3.01126 7.40476 2.46248 8.30383ZM15.8498 7.69919C15.2319 8.0451 14.6202 8.40121 14.0033 8.74897C13.9126 8.79766 13.8215 8.84727 13.7454 8.91682C15.7854 10.0802 17.826 11.2422 19.866 12.406C20.1555 12.5539 20.3049 12.879 20.295 13.1924C20.2936 15.1343 20.2997 17.0767 20.2922 19.0191C21.8906 18.4756 23.0986 16.9932 23.341 15.3472C23.5059 14.3025 23.2945 13.205 22.7575 12.291C22.3445 11.5802 21.737 10.9816 21.0153 10.5763C19.3487 9.62394 17.6794 8.67571 16.0133 7.72284C15.963 7.69641 15.9038 7.65793 15.8498 7.69919ZM12.3945 9.66613C11.5465 10.1484 10.7012 10.6366 9.84986 11.1128C9.84564 12.1598 9.84564 13.2063 9.84986 14.2533C10.7661 14.762 11.6686 15.2948 12.5853 15.803C13.502 15.2952 14.4045 14.762 15.3203 14.2529C15.325 13.2063 15.3245 12.1593 15.3207 11.1128C14.4276 10.6162 13.5466 10.0978 12.6544 9.60075C12.5651 9.53445 12.4758 9.63228 12.3945 9.66613ZM16.4714 11.7865C16.4578 14.1258 16.4705 16.4656 16.4653 18.8048C16.4667 19.0849 16.2985 19.352 16.0523 19.4874C14.3289 20.4671 12.6088 21.4534 10.8835 22.4304C10.9117 22.4637 10.9423 22.4953 10.9751 22.525C12.1925 23.4899 13.9107 23.7852 15.3898 23.2947C16.2802 23.0067 17.0784 22.4485 17.6516 21.7172C18.2 21.0273 18.5406 20.1806 18.6261 19.3084C18.675 18.7242 18.6449 18.1371 18.6529 17.5515C18.6458 16.0394 18.6679 14.5264 18.6421 13.0153C17.9213 12.6008 17.2048 12.177 16.4714 11.7865ZM9.17469 19.0529C8.92333 19.2036 8.59256 19.198 8.34354 19.046C7.08435 18.3268 5.82376 17.6099 4.5641 16.8912C4.09472 16.6343 3.64273 16.345 3.16302 16.1081C3.02301 16.9561 3.10993 17.8432 3.43835 18.6407C3.74234 19.3886 4.2446 20.0586 4.88547 20.5585C5.55782 21.0848 6.37582 21.4293 7.22765 21.5355C8.23782 21.6695 9.28934 21.4687 10.1745 20.9684C11.8528 20.0141 13.5288 19.0557 15.2075 18.1014C15.2526 18.0676 15.3363 18.0412 15.3226 17.9697C15.3212 17.1648 15.3278 16.3598 15.3193 15.5549C13.268 16.716 11.2242 17.8891 9.17469 19.0529Z">
							</path>
						</svg>
					</div>
					<span>GPT</span>
				</div>
				<div class="right">
					<span class="number-item">9</span>
					<span class="number-item">9</span>
					<span class="number-item">9</span>
					<span class="dot">,</span>
					<span class="number-item">9</span>
					<span class="number-item">9</span>
					<span class="number-item">9</span>
					<span class="dot">.</span>
					<span class="number-item">9</span>
					<span class="number-item">9</span>
				</div>
			</div>
		</div>

		<div class="sub-title">
			<span class="white-color-text">{{$t('推荐投资')}}</span>
			<swiperMode2 :list="list1"></swiperMode2>
		</div>

		<swiperMode :list="list2" @openSubmit="(id) => $emit('openSubmit', id)"></swiperMode>
	</div>
</template>
<script>
import swiperMode from './model1Swiper.vue';
import swiperMode2 from './model1Swiper2.vue';
export default {
	components: {
		swiperMode,
		swiperMode2,
	},

	props: {
		list1: {
			type: Array,
			default: () => [],
		},
		list2: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
		};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.top-section {
	width: 100%;
	border-radius: 12px;
	border: 2px solid #252731;
	background: #12141e;
	padding-bottom: 20px;

	.sub-title {
		width: 90%;
		margin: 30px auto;
		display: flex;
		align-items: center;

		.white-color-text {
			margin-right: 20px;
			font-size: 22px;
		}
	}

	.top-banner {
		width: 90%;
		height: 151px;
		margin: 30px auto 0;
		position: relative;

		.text-wrap {
			width: 100%;
			position: absolute;
			z-index: 10;
			display: flex;
			top: 50px;
			padding: 0 50px;
			justify-content: space-between;

			.right {
				display: flex;
				align-items: center;
				color: #fff;
				text-shadow: 0 .89999998px .89999998px rgba(0, 0, 0, .25);
				font-size: 40px;

				.number-item {
					width: 36px;
					height: 50px;
					line-height: 50px;
					margin-left: 8px;
					border-radius: 2px;
					border: 1px solid #5c3b1d;
					background: radial-gradient(50% 50% at 50% 50%, #a46125 0, #1c1919 100%);
					font-weight: 700;
					text-align: center;
				}
			}

			.left {
				display: flex;
				align-items: center;

				.white-color-text {
					font-size: 30px;
				}

				.svg-img {
					margin: 0 5px;
				}
			}
		}
	}
}
</style>